import styled, { css } from 'styled-components/macro';
import { ImageType } from '../../../hooks/api/queries/useProducts';
import { S3_URL } from '../../../styles/constants';

interface Props {
  image?: ImageType;
  background?: boolean;
}

export const WImage = ({ image, background = false }: Props) => {
  // console.log('[DEBUG] IMAGE', `${S3_URL}${image?.path}`);

  return image?.path ? (
    <Image
      src={`${S3_URL}${image.path}`}
      alt={image.alt}
      background={background}
    />
  ) : (
    <Image src="/images/category-pic-1.png" background={true} />
  );
};

const Image = styled.img<{ background: boolean }>`
  width: 100%;
  ${({ background }) =>
    background &&
    css`
      background: rgba(0, 0, 0, 0.05);
    `}
`;
